import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldExclamationIcon, HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import useAuthStore from '../store/authStore';

export default function ForbiddenPage() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="flex justify-center mb-4">
            <ShieldExclamationIcon className="h-24 w-24 text-red-500" />
          </div>
          <h1 className="text-6xl font-bold text-red-600">403</h1>
          <h2 className="text-3xl font-semibold text-gray-900 mt-4">Access Forbidden</h2>
          <p className="text-gray-600 mt-2">
            You don't have permission to access this resource.
          </p>
        </div>

        <div className="mb-6 p-4 bg-red-50 rounded-lg">
          <p className="text-sm text-red-800">
            <strong>Your Role:</strong> {user?.role || 'Unknown'}
          </p>
          <p className="text-sm text-red-800 mt-1">
            This page requires higher privileges. Please contact your administrator if you believe you should have access.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="btn-primary flex items-center justify-center gap-2"
          >
            <HomeIcon className="h-5 w-5" />
            Go to Dashboard
          </Link>
          <button
            onClick={() => navigate(-1)}
            className="btn-secondary flex items-center justify-center gap-2"
          >
            <ArrowLeftIcon className="h-5 w-5" />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
